import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React, { memo } from 'react';
import Box from "@material-ui/core/Box";
import useStyles from './styles';

var Space = function (props) {
  var hide = props.hide,
      children = props.children,
      spaceHeight = props.spaceHeight,
      spaceWidth = props.spaceWidth,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
      rest = _objectWithoutPropertiesLoose(props, ["hide", "children", "spaceHeight", "spaceWidth", "direction"]);

  var classes = useStyles(props);
  if (hide) return null;
  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    className: classes.root
  }), children);
};

export default /*#__PURE__*/memo(Space);